import { MutationKey } from '@shared/config';
import type { TFormErrorResponse } from '@shared/types';
import { type UseMutationResult, useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import type {
  RecoveryPasswordRequest,
  RecoveryPasswordResponse,
} from '../../types';
import { authApi } from '../../authApi';
import { showNotification } from '@shared/utils';

export const useRecoverPassword = (): UseMutationResult<
  RecoveryPasswordResponse,
  AxiosError<TFormErrorResponse>,
  RecoveryPasswordRequest
> => {
  return useMutation({
    mutationKey: [MutationKey.RECOVER_PASSWORD],
    mutationFn: data => authApi.recoveryPassword(data),
    onSuccess: () => {
      showNotification({
        variant: 'info',
        message:
          'Проверьте вашу почту. На указанный Email отправлена ссылка для восстановления пароля',
      });
    },
  });
};
